var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 39.5,
    height: 19.5,
    rx: 1.75,
    fill: "#EDECF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 39.5,
    height: 19.5,
    rx: 1.75,
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7210_34865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9012 13.7716H16.957L18.1731 6.25266H20.1171L18.9012 13.7716Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9492 6.43646C25.5657 6.28432 24.9575 6.11635 24.2054 6.11635C22.2855 6.11635 20.9335 7.14015 20.9252 8.60389C20.9092 9.68383 21.8932 10.2837 22.6291 10.6437C23.3812 11.0117 23.6369 11.2519 23.6369 11.5798C23.6293 12.0836 23.0291 12.3157 22.4694 12.3157C21.6932 12.3157 21.2773 12.196 20.6453 11.9158L20.3892 11.7957L20.1172 13.4835C20.5732 13.6912 21.4133 13.8756 22.2855 13.8837C24.3254 13.8837 25.6535 12.8757 25.6692 11.3159C25.677 10.4599 25.1574 9.80407 24.0373 9.26814C23.3573 8.92411 22.9409 8.69213 22.9409 8.34012C22.9489 8.02012 23.2931 7.69235 24.0607 7.69235C24.6927 7.6763 25.1571 7.82822 25.5089 7.98025L25.6848 8.06009L25.9492 6.43646Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5314 11.1079C28.6915 10.676 29.3076 9.00417 29.3076 9.00417C29.2995 9.02023 29.4674 8.56425 29.5634 8.28432L29.6992 8.9322C29.6992 8.9322 30.0674 10.732 30.1474 11.1079C29.8435 11.1079 28.9154 11.1079 28.5314 11.1079ZM30.9312 6.25266H29.4274C28.9637 6.25266 28.6113 6.38852 28.4113 6.87651L25.5234 13.7715H27.5634C27.5634 13.7715 27.8992 12.8435 27.9714 12.6436C28.1952 12.6436 30.1797 12.6436 30.4676 12.6436C30.5234 12.9076 30.6996 13.7715 30.6996 13.7715H32.4997L30.9312 6.25266Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3312 6.25266L13.4272 11.3799L13.2192 10.34C12.8672 9.14015 11.7632 7.83652 10.5312 7.18833L12.2752 13.7636H14.3311L17.387 6.25266H15.3312Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.66 6.25266H8.532L8.5 6.40458C10.94 7.02854 12.556 8.53256 13.2199 10.3403L12.5399 6.88469C12.428 6.40447 12.084 6.2685 11.66 6.25266Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7210_34865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 7.76732,
    fill: "white",
    transform: "translate(8.5 6.11635)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.250eecae13c25a9b46afabb1ea8bf27f.svg";
export { ForwardRef as ReactComponent };